// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1J9Pe","sendOtp":"AuthorizeToLogin_sendOtp__1xTS3"};